import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("CARGAR_HORARIO", newActions, newReducers);

const cargarHorarioThunk = (data) => {
  const url = `${baseUrl}/cargarHorarioProfesional`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckServicios = createDuck("SERVICIO_OPTIONS_BY_PROFESIONAL", newActions, newReducers);

const opcionesServiciosByProfesionalThunk = (id) => {
  const url = `${baseUrl}/getServiciosByProfesional/${id}`;
  return createThunk(axios, "get", duckServicios.actions, url, null);
};

const duckHorarioById = createDuck("HORARIO_BY_ID", newActions, newReducers);

const horarioByIdThunk = (id) => {
  const url = `${baseUrl}/getHorarioById/${id}`;
  return createThunk(axios, "get", duckHorarioById.actions, url, null);
};

const duckEditHorario = createDuck("EDITAR_HORARIO", newActions, newReducers);

const editarHorarioThunk = (data) => {
  const url = `${baseUrl}/editarHorarioProfesional`;
  return createThunk(axios, "post", duckEditHorario.actions, url, data);
};
export default {
  duck,
  cargarHorarioThunk,
  duckServicios,
  opcionesServiciosByProfesionalThunk,
  duckHorarioById,
  horarioByIdThunk,
  duckEditHorario,
  editarHorarioThunk,

};
